import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';

import App from './App';
import getConfig from './config';

const config = getConfig();
const { environment } = config;

const newRelicFileName = environment === 'production'
  ? 'newrelic-prod'
  : 'newrelic-test';

const newRelicFilePath = `/newrelic/${newRelicFileName}.js`;

const Root = () => (
  <>
    <Helmet>
      <script src={newRelicFilePath} type="text/javascript" />
    </Helmet>
    <App />
  </>
);

ReactDOM.render(<Root />, document.getElementById('root'));
